import Aos from "aos";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Container, Grid, Button } from "@mui/material";

export default function Category() {
	const { categoryName } = useParams();
	const [title, setTitle] = useState(
		`Product - ${categoryName.charAt(0).toUpperCase() + categoryName.slice(1)}`,
	);
	const [description, setDescription] = useState(
		"Broadcast Store is a professional audiovisual equipment company providing services like consignment, system integration, and media migration etc.",
	);

	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		document.title = title;
		document
			.getElementById("meta-description")
			.setAttribute("content", description);
		Aos.init({ duration: 2000 });
		window.scrollTo(0, 0);
	}, [title, description]);

	useEffect(() => {
		const fetchProductsByCategory = async () => {
			try {
				setLoading(true);

				const categoryRes = await axios.get(
					"https://thebroadcaststore.co/admins/api/all-category",
				);
				const allCategories = categoryRes.data;

				const matchedCategory = allCategories.find(
					(cat) => cat.title.toLowerCase() === categoryName.toLowerCase(),
				);

				if (!matchedCategory) {
					console.warn("No category matched:", categoryName);
					setProducts([]);
					setLoading(false);
					return;
				}

				const productRes = await axios.get(
					"https://thebroadcaststore.co/admins/api/all-products",
				);
				const allProducts = productRes.data;

				const filteredProducts = allProducts.filter(
					(product) =>
						String(product.category_id) === String(matchedCategory.id),
				);

				setProducts(filteredProducts);
			} catch (error) {
				console.error("Error fetching category-based products:", error);
				setProducts([]);
			} finally {
				setLoading(false);
			}
		};

		fetchProductsByCategory();
	}, [categoryName]);

	return (
		<>
			<div className="search-container-contact-bannerText innerban">
				<h1
					className="contact-heading"
					data-aos="fade-up">
					{loading ? (
						"Loading..."
					) : (
						<>
							{products.length > 0
								? `${categoryName} Products`
								: "No Products Found"}
						</>
					)}
				</h1>
			</div>

			{!loading && products.length > 0 && (
				<Grid
					className="ft-products brd-line"
					id="all-pro">
					<Container>
						<div className="ft-pro-head">
							<Row className="products-heading">
								<Col>
									<span
										data-aos="fade-right"
										data-aos-offset="300"
										data-aos-easing="ease-in-sine"
										className="webkit-text products-bgtext">
										PRODUCTS
									</span>
									<div data-aos="fade-up">
										<h2 className="heading">{`${
											categoryName.charAt(0).toUpperCase() +
											categoryName.slice(1)
										} Products`}</h2>
									</div>
								</Col>
							</Row>
						</div>

						<div className="products-container">
							{products.map((product) => (
								<div
									className="ftrd-slide"
									key={product.id}>
									<div className="ftrd-pro">
										<div className="product">
											<h4 className="title">{product.title}</h4>
											<div className="pro-image">
												<img
													src={
														/^https?:\/\//i.test(product.img_path)
															? product.img_path
															: `https://thebroadcaststore.co/admins/public/${product.img_path}`
													}
													alt=""
												/>
											</div>
											<p className="short-des">{product.short_desc}</p>
											<div className="price-btn">
												<p className="price">Call for Price</p>
												<Button className="lrn-more cart">
													<Link to={`/product-detail/${product.slug}`}>
														Learn More
													</Link>
												</Button>
											</div>
										</div>
									</div>
								</div>
							))}
						</div>
					</Container>
				</Grid>
			)}
		</>
	);
}
